import { render, staticRenderFns } from "./PackagingTracking_HuonTas_summary.vue?vue&type=template&id=5ca0d70d"
import script from "./PackagingTracking_HuonTas_summary.vue?vue&type=script&lang=js"
export * from "./PackagingTracking_HuonTas_summary.vue?vue&type=script&lang=js"
import style0 from "./PackagingTracking_HuonTas_summary.vue?vue&type=style&index=0&id=5ca0d70d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports